export default __webpack_public_path__ + "f76468fea61209a9a7e240009c6d8ce7.jpg";